import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { CommonFunctions } from '@shared/common-functions';
import { DeleteConfirmationModalComponent } from '@shared/components/delete-confirmation-modal/delete-confirmation-modal.component';
import { DriverService } from '@shared/components/driver/services/driver.service';
import { InviteDriverModalComponent } from '@shared/components/invite-driver/invite-driver-modal/invite-driver-modal.component';
import { ResetPasswordConfirmationComponent } from '@shared/components/reset-password-confirmation/reset-password-confirmation.component';
import { itemsPerPageList, MSG_DELETE_ACCOUNT, RESET_PASSWORD_CONFIRMATION, USER_ROLES } from '@shared/constant/shared.constant';
import { CommonMenuService } from '@shared/services/common-util.service';
import { CompanyService, BreadcrumbItem } from '@shared/services/company.service';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { MenuService } from '@core/services/menu.service';
import { ToastService } from '@shared/services/toast.service';
import { autoUnsubWith, Utility } from '@shared/services/utility.abstract';
import { MenuItem } from 'primeng/api';
import * as XLSX from 'xlsx';
import { SuperAdminService } from '@core/services/super-admin.service';
import { ItemPerPage } from '@core/models/file-response.model';
import { DriverList } from '@core/models/booking.model';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';

@Component({
  selector: 'app-role-based-user-list',
  templateUrl: './role-based-user-list.component.html',
  styleUrls: ['./role-based-user-list.component.scss']
})
export class RoleBasedUserListComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  driverList: any;
  itemsPerPage: number = 10;
  totalDriverRecord: number;
  currentSkip: number = 0;
  currentPageUpcoming: number = 1;
  driverName: any;
  driverEmail: any;
  driverNumber: any;
  selectDriverStatus: any;
  CustomItemPerPageBy: ItemPerPage[] = itemsPerPageList;
  items: MenuItem[] | undefined;
  SearchItemPerPageBy: any;
  dummy: string = '../../../../assets/images/dummy-img.png';
  activeItem: any;
  excelFile: DriverList[] = [];
  driverListRequest: any;
  goToCurrentTab: boolean = false;
  showInput: boolean = false;
  role: string = '';
  roleRoute: string = '';
  searchStatus: any;
  selectStatus: { name: string; value: boolean }[] = [];
  chackFilterType: boolean = false;
  companyId: string;
  createDriverCheck: boolean = false;
  inviteDriverCheck: boolean = false;
  currentUrl: string = '';
  userRoles = USER_ROLES;
  
  constructor(
    private readonly superAdminService: SuperAdminService,
    private readonly toastService: ToastService,
    private readonly menuService: MenuService,
    private readonly companyService: CompanyService,
    private readonly router: Router,
    private readonly dialogControlService: DialogControlService,
    private readonly driverService: DriverService,
    private readonly commonMenuService: CommonMenuService,
    private readonly encryptStorage: EncryptionStorageService
  ) {
    this.role = this.encryptStorage.getItem('roleName');
    this.roleRoute = CommonFunctions.routeToBookingDetail(this.role);
  }

  ngOnInit() {
    this.currentUrl = this.router.url;
    
    this.selectStatus = [
      { name: 'All', value: null },
      { name: 'Active', value: true },
      { name: 'Inactive', value: false },
    ];
    this.getDriverListCreatedBySuperAdmin('firsttime');
    const breadcrumbObj: BreadcrumbItem[] = [
      {
        title: 'Manage Users',
      },
      {
        title: 'Drivers List',
      },
    ];

    this.companyService.setAdminHeaders('0', breadcrumbObj);
    this.goToTop();
    this.companyId = this.encryptStorage.getItem('companyId');
    this.inviteDriverCheck = this.menuService.shortNameExists(
      JSON.parse(this.encryptStorage.getItem('menuData')),
      96
    );
    this.createDriverCheck = this.menuService.shortNameExists(
      JSON.parse(this.encryptStorage.getItem('menuData')),
      2
    );
  }

  onChangePaymentStatus(event: any) {
    this.searchStatus = event.value;
  }

  exportData() {
    this.driverListRequest = {
      driverName: '',
      iso: '',
      mobileNUmber: '',
      driverEmail: '',
      status: null,
      pageNumber: 0,
      pageSize: 0,
      timeZone: 'Asia/Calcutta',
    };
    this.getDriverListExcelSheet(this.driverListRequest);
  }

  getDriverListExcelSheet(driverRequest) {
    this.superAdminService.getDriverList(driverRequest)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response) => {
        this.driverList = response.data;
        const filteredDriverList = this.driverList.map((driver) => ({
          'Driver Name': driver.driverName,
          'Driver Email': driver.email,
          'Country Code': driver.countryCode,
          'Mobile Number': driver.mobileNumber,
          'Created On': driver.dateCreated,
          Status: driver.isActive ? 'Active' : 'Inactive',
        }));
        this.exportAsExcelFile(filteredDriverList, 'driverList');
      },
      error: (_error) => {
        this.driverList = [];
      },
    });
  }

  exportAsExcelFile(data: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ['data'],
    };
    XLSX.writeFile(workbook, `${excelFileName}.xlsx`);
  }

  getDriverListCreatedBySuperAdmin(changeAction) {
    
    if (changeAction === 'reset') {
      this.driverListRequest = {
        driverName: '',
        iso: '',
        mobileNUmber: '',
        driverEmail: '',
        status: null,
        pageNumber: this.currentPageUpcoming,
        pageSize: this.itemsPerPage,
        timeZone: Utility.getLocalTimeZone(),
      };
    } else {
      if (changeAction === 'search') {
        this.driverListRequest = {
          driverName: this.driverName ? this.driverName : '',
          iso: '',
          mobileNUmber: this.driverNumber ? this.driverNumber : '',
          driverEmail: this.driverEmail ? this.driverEmail : '',
          status: this.searchStatus,
          pageNumber: 1,
          pageSize: this.itemsPerPage,
          timeZone: Utility.getLocalTimeZone(),
        };
      } else {
        this.driverListRequest = {
          driverName: this.driverName ? this.driverName : '',
          iso: '',
          mobileNUmber: this.driverNumber ? this.driverNumber : '',
          driverEmail: this.driverEmail ? this.driverEmail : '',
          status: this.searchStatus,
          pageNumber: this.currentPageUpcoming,
          pageSize: this.itemsPerPage,
          timeZone: Utility.getLocalTimeZone(),
        };
      }
    }

    this.getDriverList(this.driverListRequest, changeAction);
  }

  getDriverList(driverRequest, changeAction?: string) {
    this.superAdminService.getDriverList(driverRequest).subscribe({
      next: (response) => {
        if (changeAction === 'search') {
          this.currentSkip = 0;
          CommonFunctions.scrollTopRow('top');
        }
        this.totalDriverRecord = response.totalRecords;
        this.driverList = response.data;
        this.excelFile = this.driverList;
        
      },
      error: (_error) => {
        this.currentSkip = 0;
        this.driverList = [];
      },
    });
  }

  onPageChange(event: any) {
    this.currentSkip = event.first;
    this.currentPageUpcoming = event.page + 1;
    CommonFunctions.scrollTopRow('top');
    this.getDriverListCreatedBySuperAdmin('pageChange');
  }

  activeOrDeactivateDriver(driverId: string) {
    
    const payload = {
      id: driverId,
    };
    this.superAdminService.activeOrDeactivateDriver(payload).subscribe({
      next: (_response: any) => {
        
      },
      error: (error) => {
        this.toastService.showToastMessage(
          'error',
          'Error',
          error.error.message
        );
      },
    });
  }

  onDropdownChange(event: any) {
    this.itemsPerPage = event.value;
    this.currentSkip = 1;
    this.currentPageUpcoming = 1;
    CommonFunctions.scrollTopRow('top');
    this.getDriverListCreatedBySuperAdmin('dropdownchange');
  }

  getFlagClass(iso: string): string {
    const lowerCaseIso = iso?.toLowerCase();
    return `fi fi-${lowerCaseIso}`;
  }

  resetFilter() {
    this.driverName = '';
    this.driverEmail = '';
    this.driverNumber = '';
    this.currentPageUpcoming = 1;
    this.itemsPerPage = 10;
    this.currentSkip = 0;
    this.SearchItemPerPageBy = null;
    this.getDriverListCreatedBySuperAdmin('reset');
    this.goToTop();
    this.searchStatus = null;
  }

  goToTop() {
    window.scrollTo({
      behavior: 'smooth',
      top: 0,
    });
  }

  showData(rowData: any) {
    const actionMap = {
      viewProfile: () => {
        this.driverService.setPreviousUrl(this.currentUrl);
        this.router.navigate([`${this.roleRoute}/driver-info`], {
          queryParams: {
            id: rowData.id,
            tab: '0',
          },
        });
      },
      createBooking: () => {
        this.routeToCreateBooking(rowData.email);
      },
      deleteAccount: () => {
        this.openDeleteModal(rowData.id);
      },
      edit: () => {
        this.superAdminService.setShowInput(true);
        this.driverService.setPreviousUrl(this.currentUrl);
        this.router.navigate([`${this.roleRoute}/driver-info`], {
          queryParams: {
            id: rowData.id,
          },
        });
      },
      resetPassword: () => {
        this.openResetModal(rowData.id);
      },
      createInvoice: () => {
        this.encryptStorage.setItem('driverId', rowData.id);
        const url = `${this.roleRoute}/invoice${this.role === USER_ROLES.SUPER_ADMIN ? `/${this.companyId}` : ''}`;

        const navigation: NavigationExtras = {
          state: {
            emailId: rowData.email,
          },
        };
        this.router.navigateByUrl(url, navigation);
      },
    };

    const config = [
      {
        label: '',
        icon: '',
        escape: false,
      },
      {
        label: 'View Profile',
        icon: 'common-icon view-profile',
        visible: this.menuService.shortNameExists(
          JSON.parse(this.encryptStorage.getItem('menuData')),
          10
        ),
        escape: false,
        command: actionMap.viewProfile,
      },
      {
        label: 'Create Booking',
        icon: 'common-icon custom-createbooking',
        visible: this.menuService.shortNameExists(
          JSON.parse(this.encryptStorage.getItem('menuData')),
          65
        ),
        escape: false,
        command: actionMap.createBooking,
      },
      ...(this.roleRoute !== 'manager'
        ? [
          {
            label: 'Delete Account',
            icon: 'custom-delete',
            escape: false,
            command: actionMap.deleteAccount,
          },
        ]
        : []),
      {
        label: 'Edit',
        icon: 'common-icon custom-editicon',
        visible: this.menuService.shortNameExists(
          JSON.parse(this.encryptStorage.getItem('menuData')),
          33
        ),
        escape: false,
        command: actionMap.edit,
      },
      {
        label: 'Reset Password',
        icon: 'common-icon custom-reset',
        escape: false,
        visible: this.menuService.shortNameExists(
          JSON.parse(this.encryptStorage.getItem('menuData')),
          26
        ),
        command: actionMap.resetPassword,
      },
      {
        label: 'Create Invoice',
        icon: 'common-icon create-invoice',
        escape: false,
        visible: this.menuService.shortNameExists(
          JSON.parse(this.encryptStorage.getItem('menuData')),
          97
        ) || this.menuService.shortNameExists(
          JSON.parse(this.encryptStorage.getItem('menuData')),
          96
        ),
        command: actionMap.createInvoice,
      },
    ];
    this.items = this.commonMenuService.commonShowData(config);
  }

  routeToCreateBooking(emailId: any): void {
    const url = `${this.roleRoute}/create-booking`;
    const navigationExtras: NavigationExtras = {
      state: {
        emailId: emailId,
      },
    };
    this.router.navigateByUrl(url, navigationExtras);
  }

  openResetModal(id: string) {
    this.dialogControlService.openDialog(ResetPasswordConfirmationComponent, {
      width: '23%',
      data: {
        headerText: 'Reset',
        bodyText: RESET_PASSWORD_CONFIRMATION,
        id: id,
        user: this.userRoles.DRIVER,
      },
    });
  }

  openDeleteModal(id: string) {
    this.dialogControlService.openDialog(DeleteConfirmationModalComponent, {
      width: '23%',
      data: {
        headerText: 'Delete',
        bodyText: MSG_DELETE_ACCOUNT,
        id: id,
      },
    });
  }

  onlyNumber(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  }

  goToDriverInfoPage(rowData: any) {
    this.driverService.setPreviousUrl(this.currentUrl);
    this.router.navigate([`${this.roleRoute}/driver-info`], {
      queryParams: {
        id: rowData.id,
      },
    });
  }

  get viewProfileCheck(): boolean {
    return this.menuService.shortNameExists(
      JSON.parse(this.encryptStorage.getItem('menuData')),
      10
    );
  }

  InviteDriverModalComponent() {
    this.dialogControlService.openDialog(InviteDriverModalComponent, {
      width: '30%',
    });
  }
}
